import styled from 'styled-components';

const TextSeparator = styled.li`
  user-select: none;
  margin: 0 12px;
`;

export { TextSeparator };
